import { InjectedPropsProvider } from 'Components/Core/InjectedPropsContext';
import { getWorksheetProviderProps } from 'Components/Worksheets/Core';
import {
  WorksheetInjectedConsumerProps,
  WorksheetInjectedPropsModifier,
} from 'Components/Worksheets/Core/WorksheetEditorInjectedPropsProvider/types';
import { RootState } from 'Data/Redux';
import { actions } from 'Data/ReduxViewModels/TestPages';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Injector to use when a test page needs to emulate
 * a real worksheet
 **/
let TestWorksheetInjectedPropsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();

  const getProviderProps = useCallback(
    (consumerProps: WorksheetInjectedConsumerProps, modifiers: Array<WorksheetInjectedPropsModifier>) =>
      getWorksheetProviderProps(
        consumerProps,
        {
          worksheetId: '00000000-0000-0000-0000-000000000000',
          locked: false,
          setValue: (update: any) => {
            dispatch(actions.setValue(update));
          },
          synchronise: () => {},
          worksheetSelector: (state: RootState) => state.testPages.data,
          worksheetConfigSelector: (state: RootState) => state.testPages.config,
          worksheetTypeSelector: (state: RootState) => ({}),
          addArrayEntry: (payload) => {
            dispatch(actions.addArrayEntry(payload));
          },
          removeArrayEntry: (payload) => {
            dispatch(actions.removeArrayEntry(payload));
          },
        },
        modifiers
      ),
    [dispatch]
  );

  return <InjectedPropsProvider getProviderProps={getProviderProps}>{children}</InjectedPropsProvider>;
};

export { TestWorksheetInjectedPropsProvider };
export default TestWorksheetInjectedPropsProvider;
